import type { IconName } from '@ui/elements/Icon'

import {
  CofidisMonthlyApplicationFormValues,
  CofidisSectionProps,
} from '../types'

import IdentitySection from './IdentitySection'
import ResidenceSection from './ResidenceSection'
import EmploymentSection from './EmploymentSection'
import BankingSection from './BankingSection'
import TermsSection from './TermsSection'

export type CofidisSectionConfig = {
  /** Unique section key; use with cofidis:{name}.title for i18n (same as in section components). */
  name: string
  /** Icon shown in the section list (e.g. in SectionListItem). */
  icon: IconName
  fields: (keyof CofidisMonthlyApplicationFormValues)[]
  Component: React.ComponentType<CofidisSectionProps>
}

/** Section order: Identity → Residence Address → Employment → Bank → Terms & Policies (source of truth). */
export const cofidisMonthlyApplicationSections: CofidisSectionConfig[] = [
  {
    name: 'identity',
    icon: 'user-circle',
    fields: [
      'title',
      'firstName',
      'lastName1',
      'lastName2',
      'idType',
      'idNumber',
      'idCessationOfValidityDate',
      'nationality',
      'birthDate',
      'birthCountry',
      'birthTown',
      'familySituation',
      'familyExpenses',
      'childSupportNumber',
      'email',
      'sustainableSupport',
      'phoneNumber',
      'phoneNumber2',
    ],
    Component: IdentitySection,
  },
  {
    name: 'residence',
    icon: 'home-2',
    fields: [
      'wayType',
      'wayDescription',
      'wayNumber',
      'floor',
      'letter',
      'additionalAddress',
      'zipCode',
      'town',
      'country',
      'homeType',
      'homeExpenses',
      'entranceDate',
    ],
    Component: ResidenceSection,
  },
  {
    name: 'employment',
    icon: 'briefcase',
    fields: [
      'professionCode',
      'contractType',
      'contractStartDate',
      'contractEndDate',
      'salary',
      'salaryMonthsNumber',
      'companyName',
      // 'companyId',
      'companyWayType',
      'companyWayDescription',
      'companyWayNumber',
      'companyZipCode',
      'companyTown',
      'companyPhone',
    ],
    Component: EmploymentSection,
  },
  {
    name: 'banking',
    icon: 'coin',
    fields: [
      'iban',
      'bankAccountHolderName',
      'bankAccountOpeningDate',
      'editionMode',
    ],
    Component: BankingSection,
  },
  {
    name: 'terms',
    icon: 'file-invoice',
    fields: ['vedaconAcceptance', 'internalOptin', 'partnerOptin'],
    Component: TermsSection,
  },
]

export {
  BankingSection,
  IdentitySection,
  ResidenceSection,
  EmploymentSection,
  TermsSection,
}
